var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeShow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.406 14.026C21.716 10.438 18.335 8 14.516 8c-3.85 0-7.232 2.438-8.922 6.026a1.156 1.156 0 0 0-.094.474c0 .203.031.372.094.508C7.284 18.596 10.665 21 14.516 21c3.819 0 7.2-2.404 8.89-5.992.063-.136.094-.305.094-.474a1.21 1.21 0 0 0-.094-.508zm-8.89 5.349c-2.505 0-4.508-2.167-4.508-4.875 0-2.675 2.003-4.875 4.508-4.875 2.473 0 4.507 2.2 4.507 4.875v.034c0 2.674-2.034 4.875-4.507 4.875v-.034zm0-8.125c-.282.034-.564.068-.814.135.188.271.281.61.281.982 0 .88-.657 1.591-1.47 1.591-.345 0-.658-.101-.909-.304-.062.27-.094.575-.094.846 0 1.794 1.347 3.25 3.006 3.25 1.659 0 3.005-1.456 3.005-3.25s-1.346-3.216-3.005-3.216v-.034z",
    fill: "#1E2B3B",
    fillOpacity: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShow);
export default __webpack_public_path__ + "static/media/eye-show.cb2c8013a74c198341160ce00ab493e7.svg";
export { ForwardRef as ReactComponent };